import {
  CPSC_CITATION_FIELDS,
  CPSC_ENTITY_FIELDS,
  CPSC_PRODUCT_IDENTIFIER_FIELDS,
  CPSC_TEST_REPORT_FIELDS,
} from '../pga/CPSC_CPS/util'

export const merchandiseDuty = (htsus = '') => ({
  merchandiseDutyId: '',
  hsDataDtl: {
    pgaRuling: []
  },
  htsDescription: '',
  isCommodityDuty: 2,
  htsus: htsus,
  manifestQuantity: {
    quantity: (0).toFixed(2),
    units: '_BLANK_'
  },
  invoiceQuantity: {
    quantity: (0).toFixed(2),
    units: '_BLANK_'
  },
  additionalQuantity: {
    quantity: (0).toFixed(2),
    units: '_BLANK_'
  },
  enteredValue: (0).toFixed(2),
  adjustedValue: (0).toFixed(2),
  duty: (0).toFixed(2),
  otherFee: (0).toFixed(2),
  mpf: {
    rate: (0).toFixed(2),
    fee: (0).toFixed(2)
  },
  hmf: {
    rate: (0).toFixed(2),
    fee: (0).toFixed(2)
  },
  IRTax: (0).toFixed(2),
  irInfo: {},
  dutyRate: (0).toFixed(2),
  charges: (0).toFixed(2),
  additionalDuties: { userFees: [] }
})

// Provides a base line time object
export const merchandiseLineItem = () => ({

  grossWeight: {
    weight: (0).toFixed(2),
    weightUnits: '_BLANK_'
  },
  pgaFlagInfos: [],
  productClaimCode: 'NONE',
  availableProductClaimCode: [],
  countryOfOrigin: '',
  permitNumber: '',
  permitTypeCode: '',
  pgaProgram: '',
  merchandiseId: 0,

  // Commodity Duty Fields
  commodityMerchandiseDutyId: '',
  manufacturerId: '',
  merchandiseDuties: [merchandiseDuty()]
})

export const initialValues = () => {
  return {
    psc: {

    },
    importer: {
      importer: {
        name: '',
        addressInfo: {
          STREET_NAME: '',
          CITY: '',
          COUNTRY_SUB_ENTITY: '',
          POSTAL_CODE: '',
          COUNTRY: ''
        },
        importerId: '',
      },
      consignee: {
        name: '',
        addressInfo: {
          STREET_NAME: '',
          CITY: '',
          COUNTRY_SUB_ENTITY: '',
          POSTAL_CODE: '',
          COUNTRY: ''
        },
        consigneeId: ''
      },
      headerParties: [
        {
          headerPartyType: '',
          name: '',
          addressInfo: {
            STREET_NAME: '',
            CITY: '',
            COUNTRY_SUB_ENTITY: '',
            POSTAL_CODE: '',
            COUNTRY: ''
          },
          headerId: ''
        }
      ],
      sameAsFlags: {
        sellerAsShipper: 2,
        manufacturerAsShipper: 2,
        containerStufferAsManufacturer: 2,
        consolidatorAsShipper: 2,
        consigneeAsImporter: 2,
        notifyPartyAsImporter: 2,
        buyerAsImporter: 2,
      },
      related: 2,
      designatedNotifyParty: '',
      usStateOfDestCode: ''
    },
    entryTypeInfo: {
      consolidatedSummaryIndicator: false,
      liveEntryIndicator: false,
      entryType: '',
      summaryDate: {},
      filerCode: '',
      entryNumber: '',
      checkDigit: '',
      statementPaymentType: '',
      portCode: {
        portCode: '',
        portStringVal: ''
      },
      entryDate: {},
      countryOfExport: '',
      ftzFilingDate: {},
      zoneStatus: '',
      primaryStatementPrintDate: {
        epochs: Date.now()
      },
      releaseDate: {
        epochs: Date.now()
      },
      periodicStatementMonths: '',
      mpfOverrideFlag:"0"
    },
    bondInfo: {
      bondType: '',
      suretyNumber: '',
      bondValue: '',
      bondWaiver: false,
      bondWaiverReasonCode: 'Code A'
    },
    transportInfo: {
      modeOfTransport: '',
      importDate: {},
      exportDate: {},
      arrivalDate: {},
      truckNo: '',
      importingCarrier: '',
      tripInformation: '',
      flightNo: '',
      vesselCode: '',
      foreignPortOfLadingCode: '',
      destTimeZone: '',
      USportOfUnladingCode: '',
      airCarrierCode: '',
      centralizedExaminationSite: ''
    },
    bolInfo: {
      nonAms: '',
      splitBill: '',
      itDate: {},
      airCarrierCode: '',
      bol: {
        bolnumber: '',
        boltype: ''
      },
      manifestQuantity: {
        quantity: (0).toFixed(2),
        units: 'KG'
      },
      locationOfGoods: '',
      currentLocationOfGood: '',
      container: [
        {
          number: '',
          size: '',
          containerId: ''
        }
      ]
    },
    descriptionOfMerchandise: {
      grossWeight: {
        weight: 0,
        weightUnits: 'KG'
      },
      manifestQuantity: {
        quantity: (0).toFixed(2),
        units: 'KG'
      },
      totalValue: 0,
      manufacturerId: '',
      entrySummaryInvoices :[invoiceItemData()],
     // merchandiseLineItems: [merchandiseLineItem()],
      mpf: {
        fee: 0
      },
      hmf: {
        fee: 0
      },
      duty: 0,
      tax: 0,
      fee: 0,
      grandTotal: 0,
      bolDocId: ''
    },
    laceyAct: {
      commercialDesc: '',
      charDesc: '',
      PGAItemList: [],
      containers: [
        {
          containerid: '',
          containerNumber: '',
          desccode: '',
          alphaprefix: '',
          checkdigit: ''
        }
      ],
      individualName: '',
      telNumber: '',
      email: '',
      entityAddress1: '',
      entityAddress2: '',
      aptOrSuiteNo: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      declarationCert: false,
      dateOfSign: null
    },
    declarationSection: {},
    fieldValidations: {}
  }
}

export const getInitialLaceyAct = () => ({
  commercialDesc: '',
  charDesc: '',
  PGAItemList: [],
  containers: [],
  individualName: '',
  telNumber: '',
  email: '',
  entityAddress1: '',
  entityAddress2: '',
  aptOrSuiteNo: '',
  city: '',
  state: '',
  zip: '',
  country: '',
  declarationCert: false,
  dateOfSign: 0
})

export const getInitialTSCA = () => ({
  declarationCert: false,
  dateOfSign: 0,
  disclaimCode: 2,
  declarationCode: 2
})

export const getInitialFDAFOO = () => ({
  commercialDesc: '',
  dateOfSign: 0,
  disclaimCode: 2,
  FDAFOO_AOC_List: [],
  FDAFOO_PQ_List: [],
  APHAVS_COMMODITY_Values: [],
  ATFATF_LICENSE_Values: [],
  PSX_REPEATED_INGREDIENT_Values: [],
  FDAFOO_SOURCE_TYPE_List: [],
  FDADRU_CONSTITUENT_ELEMENT_Values: [],
  FDADRU_LOTNUM_Values: [],
  COMO_VALUES : [],
  containers: [],
  VEHICLE_INFO_Values: [],
  CPSC_PRODUCT_IDENTIFIER_List: [],
  CPSC_ENTITY_ITL_List: [],
  CPSC_ENTITY_LAB_List: [],
  CPSC_TEST_REPORT_ITL_List: [],
  CPSC_TEST_REPORT_LAB_List: [],
})

export const getInitialFDA = () => ({
  commercialDesc: '',
  dateOfSign: 0,
  disclaimCode: 2
})

export const getInitialNHTSA = () => ({

})


export const getNewPGAItem = (index = 1) => ({
  genusName: {
    key: 'genusName' + '.' + index,
    value: '',
    dataType: 'STRING',
    isOptional: 'Y',
    uiLabel: 'Genus Name',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Genus Name',
    PGAId: 'genusName',
    isRepeated: 'Y',
    lengthClass: "22X",
    id: Math.random()+"_"+Math.random(),
  },
  speciesName: {
    key: 'speciesName' + '.' + index,
    value: '',
    dataType: 'STRING',
    isOptional: 'Y',
    uiLabel: 'Species Name',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Species Name',
    PGAId: 'speciesName',
    isRepeated: 'Y',
    lengthClass: "22X",
    id: Math.random()+"_"+Math.random(),
  },
  countryCode: {
    key: 'countryCode' + '.' + index,
    value: '',
    dataType: 'STRING',
    isOptional: 'Y',
    uiLabel: 'Country Code',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Country Code',
    PGAId: 'countryCode',
    isRepeated: 'Y',
    lengthClass: "2X",
    id: Math.random()+"_"+Math.random(),
  },
  indgredientQuantity: {
    key: 'indgredientQuantity' + '.' + index,
    value: '',
    dataType: 'STRING',
    isOptional: 'Y',
    uiLabel: 'Ingredient Quantity',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Ingredient Quantity',
    PGAId: 'indgredientQuantity',
    isRepeated: 'Y',
    lengthClass: "12N",
    id: Math.random()+"_"+Math.random(),
  },
  indgredientName: {
    key: 'indgredientName' + '.' + index,
    value: '',
    dataType: 'STRING',
    isOptional: 'Y',
    uiLabel: 'Ingredient Name',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Ingredient Name',
    PGAId: 'indgredientName',
    isRepeated: 'Y',
    lengthClass: "51X",
    id: Math.random()+"_"+Math.random(),
  },
  indgredientUom: {
    key: 'indgredientUom' + '.' + index,
    value: '',
    dataType: 'STRING',
    isOptional: 'Y',
    uiLabel: 'Ingredient Uom',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Ingredient Uom',
    PGAId: 'indgredientUom',
    isRepeated: 'Y',
    lengthClass: "25X",
    id: Math.random()+"_"+Math.random(),
  }
})

export const getFDAFOO_AOC = (index = 1) => ({
  aocQualifier: {
    key: 'aocQualifier' + '.' + index,
    dataType: 'STRING',
    isOptional: 'Y',
    uiLabel: 'AOC Qualifier',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'AOC Qualifier',
    PGAId: 'aocQualifier',
    isRepeated: 'Y',
    lengthClass: '70X',
    id: Math.random()+"_"+Math.random(),
  },
  aocCode: {
    key: 'aocCode' + '.' + index,
    dataType: 'STRING',
    isOptional: 'N',
    uiLabel: 'AOC Code',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'AOC Code',
    PGAId: 'aocCode',
    isRepeated: 'Y',
    lengthClass: '5X',
    id: Math.random()+"_"+Math.random(),
  }
})

export const getFDAFOO_SOURCE_TYPE = (index = 1) => ({
  sourceTypeCode: {
    key: 'sourceTypeCode' + '.' + index,
    dataType: 'STRING',
    isOptional: 'Y',
    uiLabel: 'Source Type Code',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Source Type Code',
    PGAId: 'sourceTypeCode',
    isRepeated: 'Y',
    lengthClass: '3AN',
    id: Math.random()+"_"+Math.random(),
  },
  country: {
    key: 'country' + '.' + index,
    dataType: 'STRING',
    isOptional: 'Y',
    uiLabel: 'Country',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Country',
    PGAId: 'country',
    isRepeated: 'Y',
    id: Math.random()+"_"+Math.random(),
  },
});

export const getAPHAVS_NAMEANDCODE = (index=1) => ({
  categoryCode:{
    key: "categoryCode" + '.' + index,
    PGAId: "categoryCode",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "5AN",
    uiInputType: "DISPLAY",
    uiLabel: "Category Code",
    uiLabelDesc: "Category Code",
    id: Math.random()+"_"+Math.random(),
  },
  // commonName: {
  //   key: "commonName" + '.' + index,
  //   PGAId: "commonName",
  //   dataType: "STRING",
  //   isOptional: "Y",
  //   isRepeated: "N",
  //   lengthClass: "30X",
  //   uiInputType: "DISPLAY",
  //   uiLabel: "Common Name Of Items",
  //   uiLabelDesc: "Common Name Of Items",
  // },
  
})
export const getAPHAVS_COMMODITY = (index=1) => ({
  commodityQualCode: {
    key: "commodityQualCode" + '.' + index,
    PGAId: "commodityQualCode",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "4X",
    uiInputType: "DISPLAY",
    uiLabel: "Commodity Qualifier Code",
    uiLabelDesc: "Commodity Qualifier Code",
    id: Math.random()+"_"+Math.random(),
  },
  charDesc: {
    key: "charDesc" + '.' + index,
    PGAId: "charDesc",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "57X",
    uiInputType: "DISPLAY",
    uiLabel: "Commodity Characteristic Description",
    uiLabelDesc: "Commodity Characteristic Description",
    id: Math.random()+"_"+Math.random(),
  },
  commodityCharQual: {
    key: "commodityCharQual" + '.' + index,
    PGAId: "commodityCharQual",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "4AN",
    uiInputType: "DISPLAY",
    uiLabel: "Commodity Characteristic Qualifier",
    uiLabelDesc: "Commodity Characteristic Qualifier",
    id: Math.random()+"_"+Math.random(),
  }
})
export const getCOLA_COLA_Values = (index = 1) => ({
  colaNumber: {
    PGAId: "colaNumber",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    key: 'colaNumber' + '.' + index,
    lengthClass: "33X",
    uiInputType: "DISPLAY",
    uiLabel: "(COLA Certificate) LPCO Number",
    uiLabelDesc: "(COLA Certificate) LPCO Number",
    id: Math.random()+"_"+Math.random(),
  },
  colaExemptionCode:{
    PGAId: "colaExemptionCode",
    dataType: "STRING",
    id: Math.random()+"_"+Math.random(),
    isOptional: "Y",
    isRepeated: "Y",
    key: 'colaExemptionCode' + '.' + index,
    lengthClass: "9X",
    uiInputType: "DISPLAY",
    uiLabel: "Cola Exemption Code",
    uiLabelDesc: "Cola Exemption Code",
    }

})
export const get_REPEATED_PARTIES_PGA_Values= (index = 1) => ({
  partiesContactDetails:{id: Math.random()+"_"+Math.random(),"key":"partiesContactDetails" + '.' + index,"dataType":"STRING","isOptional":"N","uiLabel":"Contact Details","uiInputType":"DISPLAY","uiLabelDesc":"Contact Details","PGAId":"partiesContactDetails","isRepeated":"Y"},
  partiesContactEmail:{id: Math.random()+"_"+Math.random(),"key":"partiesContactEmail" + '.' + index,"dataType":"STRING","isOptional":"N","uiLabel":"Email","uiInputType":"DISPLAY","uiLabelDesc":"Email","PGAId":"partiesContactEmail","isRepeated":"Y"},
  partiesAddressAptNumber:{id: Math.random()+"_"+Math.random(),"key":"partiesAddressAptNumber" + '.' + index,"dataType":"STRING","isOptional":"N","uiLabel":"Apartment / Suite Number","uiInputType":"DISPLAY","uiLabelDesc":"Apartment / Suite Number","PGAId":"partiesAddressAptNumber","isRepeated":"Y"},
  partiesName:{id: Math.random()+"_"+Math.random(),"key":"partiesName" + '.' + index,"dataType":"STRING","isOptional":"N","uiLabel":"Name","uiInputType":"DISPLAY","uiLabelDesc":"Name","PGAId":"partiesName","isRepeated":"Y"},
  partiesCountry:{id: Math.random()+"_"+Math.random(),"key":"partiesCountry" + '.' + index,"dataType":"STRING","isOptional":"N","uiLabel":"Country","uiInputType":"DISPLAY","uiLabelDesc":"Country","PGAId":"partiesCountry","isRepeated":"Y"},
  partiesAddressLine2:{id: Math.random()+"_"+Math.random(),"key":"partiesAddressLine2" + '.' + index,"dataType":"STRING","isOptional":"Y","uiLabel":"Address Line 2","uiInputType":"DISPLAY","uiLabelDesc":"Address Line 2","PGAId":"partiesAddressLine2","isRepeated":"Y"},
  partiesAddressLine1:{id: Math.random()+"_"+Math.random(),"key":"partiesAddressLine1" + '.' + index,"dataType":"STRING","isOptional":"N","uiLabel":"Address Line 1","uiInputType":"DISPLAY","uiLabelDesc":"Address Line 1","PGAId":"partiesAddressLine1","isRepeated":"Y"},
  partiesPostalCode:{id: Math.random()+"_"+Math.random(),"key":"partiesPostalCode" + '.' + index,"dataType":"STRING","isOptional":"Y","uiLabel":"Postal Code","uiInputType":"DISPLAY","uiLabelDesc":"Postal Code","PGAId":"partiesPostalCode","isRepeated":"Y"},
  partiesState:{id: Math.random()+"_"+Math.random(),"key":"partiesState" + '.' + index,"dataType":"STRING","isOptional":"N","uiLabel":"State","uiInputType":"DISPLAY","uiLabelDesc":"State","PGAId":"partiesState","isRepeated":"Y"},
  partiesType:{id: Math.random()+"_"+Math.random(),"key":"partiesType" + '.' + index,"dataType":"STRING","isOptional":"N","uiLabel":"Parties Type","uiInputType":"DISPLAY","uiLabelDesc":"Parties Type","PGAId":"partiesType","isRepeated":"Y"},
  partiesCity:{id: Math.random()+"_"+Math.random(),"key":"partiesCity" + '.' + index,"dataType":"STRING","isOptional":"N","uiLabel":"City","uiInputType":"DISPLAY","uiLabelDesc":"City","PGAId":"partiesCity","isRepeated":"Y"},
  partiesContactName:{id: Math.random()+"_"+Math.random(),"key":"partiesContactName" + '.' + index,"dataType":"STRING","isOptional":"N","uiLabel":"Contact Name","uiInputType":"DISPLAY","uiLabelDesc":"Contact Name","PGAId":"partiesContactName","isRepeated":"Y"},
  partiesContactPhoneNumber:{id: Math.random()+"_"+Math.random(),"key":"partiesContactPhoneNumber" + '.' + index,"dataType":"STRING","isOptional":"N","uiLabel":"Phone Number","uiInputType":"DISPLAY","uiLabelDesc":"Phone Number","PGAId":"partiesContactPhoneNumber","isRepeated":"Y"},
  })

  export const get_REPEATED_OMC_AQF_Values= (index = 1) => ({
    entityNameAQF:{id: Math.random()+"_"+Math.random(),"key":"entityNameAQF" + '.' + index, "dataType": "STRING", "isOptional": "Y", "uiLabel": "Entity Name", "uiInputType": "DISPLAY", "uiLabelDesc": "Entity Name", "PGAId": "entityNameAQF", "isRepeated": "Y", "lengthClass": "32X"},
    entityAddress1AQF:{id: Math.random()+"_"+Math.random(),"key":"entityAddress1AQF" + '.' + index, "dataType": "STRING", "isOptional": "Y", "uiLabel": "Entity Address Line 1", "uiInputType": "DISPLAY", "uiLabelDesc": "Entity Address Line 1", "PGAId": "entityAddress1AQF", "isRepeated": "Y", "lengthClass": "32X"},
    entityAddress2AQF:{id: Math.random()+"_"+Math.random(),"key":"entityAddress2AQF" + '.' + index, "dataType": "STRING", "isOptional": "Y", "uiLabel": "Entity Address Line 2", "uiInputType": "DISPLAY", "uiLabelDesc": "Entity Address Line 2", "PGAId": "entityAddress2AQF", "isRepeated": "Y", "lengthClass": "32X"},
    cityAQF:{id: Math.random()+"_"+Math.random(),"key":"cityAQF" + '.' + index, "dataType": "STRING", "isOptional": "Y", "uiLabel": "Entity City", "uiInputType": "DISPLAY", "uiLabelDesc": "Entity City", "PGAId": "cityAQF", "isRepeated": "Y", "lengthClass": "21X"},
    stateAQF:{id: Math.random()+"_"+Math.random(),"key":"stateAQF" + '.' + index, "dataType": "STRING", "isOptional": "Y", "uiLabel": "Entity State", "uiInputType": "DISPLAY", "uiLabelDesc": "Entity State", "PGAId": "stateAQF", "isRepeated": "Y", "lengthClass": "3AN"},
    countryAQF:{id: Math.random()+"_"+Math.random(),"key":"countryAQF" + '.' + index, "dataType": "STRING", "isOptional": "Y", "uiLabel": "Entity Country", "uiInputType": "DISPLAY", "uiLabelDesc": "Entity Country", "PGAId": "countryAQF", "isRepeated": "Y", "lengthClass": "2A"},
    zipAQF:{id: Math.random()+"_"+Math.random(),"key":"zipAQF" + '.' + index, "dataType": "STRING", "isOptional": "Y", "uiLabel": "Entity Zip Code", "uiInputType": "DISPLAY", "uiLabelDesc": "Entity Zip Code", "PGAId": "zipAQF", "isRepeated": "Y", "lengthClass": "9X"},
})
  
export const getAPHAVS_SOURCE_TYPE = (index = 1) => ({
  sourceTypeCode: {
    key: 'sourceTypeCode' + '.' + index,
    dataType: 'STRING',
    isOptional: 'Y',
    uiLabel: 'Source Type Code',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Source Type Code',
    PGAId: 'sourceTypeCode',
    isRepeated: 'Y',
    lengthClass: '5AN',
    id: Math.random()+"_"+Math.random(),
  },
  country: {
    key: 'country' + '.' + index,
    dataType: 'STRING',
    isOptional: 'Y',
    uiLabel: 'Country',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Country',
    PGAId: 'country',
    isRepeated: 'Y',
    id: Math.random()+"_"+Math.random(),
  },
  processingStartDate:{
    key:"processingStartDate" + '.' + index,
    dataType:"STRING",
    isOptional:"N",
    uiLabel:"Processing Start Date",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Processing Start Date",
    PGAId:"processingStartDate",
    isRepeated:"Y",
    id: Math.random()+"_"+Math.random(),
  },
  processingTypeCode:{
    key:"processingTypeCode" + '.' + index,
    dataType:"STRING",
    isOptional:"N",
    uiLabel:"Source Type Code",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Source Type Code",
    PGAId:"processingTypeCode",
    isRepeated:"Y",
    id: Math.random()+"_"+Math.random(),
  },
  processingDescription:{
    key:"processingDescription" + '.' + index,
    dataType:"STRING",
    isOptional:"N",
    uiLabel:"Processing Description",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Processing Description",
    PGAId:"processingDescription",
    isRepeated:"Y",
    id: Math.random()+"_"+Math.random(),
  },
  processingEndDate:{
    key:"processingEndDate" + '.' + index,
    dataType:"STRING",
    isOptional:"N",
    uiLabel:"Processing End Date",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Processing End Date",
    PGAId:"processingEndDate",
    isRepeated:"Y",
    id: Math.random()+"_"+Math.random(),
  },
  geographicLocation:{
    key: "geographicLocation" + '.' + index,
    PGAId: "geographicLocation",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "20X",
    uiInputType: "DISPLAY",
    uiLabel: "Geographic Location",
    uiLabelDesc: "Geographic Location",
    id: Math.random()+"_"+Math.random(),
  }
})

export const getAPHAVS_NAMEANDCODE_PRODUCT = (index=1) => ({
  categoryCodeProduct:{
    key: "categoryCodeProduct" + '.' + index,
    PGAId: "categoryCodeProduct",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "5AN",
    uiInputType: "DISPLAY",
    uiLabel: "Category Code",
    uiLabelDesc: "Category Code",
    id: Math.random()+"_"+Math.random(),
  },
  commonNameProduct: {
    key: "commonNameProduct" + '.' + index,
    PGAId: "commonNameProduct",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "30X",
    uiInputType: "DISPLAY",
    uiLabel: "Common Name Of Items",
    uiLabelDesc: "Common Name Of Items",
    id: Math.random()+"_"+Math.random(),
  },
  
})
export const getAPHAVS_COMMODITY_PRODUCT = (index=1) => ({
  commodityQualCodeProduct: {
    key: "commodityQualCodeProduct" + '.' + index,
    PGAId: "commodityQualCodeProduct",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "4X",
    uiInputType: "DISPLAY",
    uiLabel: "Commodity Qualifier Code",
    uiLabelDesc: "Commodity Qualifier Code",
    id: Math.random()+"_"+Math.random(),
  },
  charDescProduct: {
    key: "charDescProduct" + '.' + index,
    PGAId: "charDescProduct",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "57X",
    uiInputType: "DISPLAY",
    uiLabel: "Commodity Characteristic Description",
    uiLabelDesc: "Commodity Characteristic Description",
    id: Math.random()+"_"+Math.random(),
  },
  commodityCharQualProduct: {
    key: "commodityCharQualProduct" + '.' + index,
    PGAId: "commodityCharQualProduct",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "4AN",
    uiInputType: "DISPLAY",
    uiLabel: "Commodity Characteristic Qualifier",
    uiLabelDesc: "Commodity Characteristic Qualifier",
    id: Math.random()+"_"+Math.random(),
  }
})
export const getAPHAVS_SOURCE_TYPE_PRODUCT = (index = 1) => ({
  sourceTypeCodeProduct: {
    key: 'sourceTypeCodeProduct' + '.' + index,
    PGAId: 'sourceTypeCodeProduct',
    dataType: 'STRING',
    isOptional: 'N',
    uiLabel: 'Source Type Code',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Source Type Code',
    isRepeated: 'Y',
    lengthClass: '5AN',
    id: Math.random()+"_"+Math.random(),
  },
  countryProduct: {
    key: 'countryProduct' + '.' + index,
    PGAId: 'countryProduct',
    dataType: 'STRING',
    isOptional: 'N',
    uiLabel: 'Country',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Country',
    isRepeated: 'Y',
    id: Math.random()+"_"+Math.random(),
  },
  processingStartDateProduct:{
    key:"processingStartDateProduct" + '.' + index,
    PGAId:"processingStartDateProduct",
    dataType:"STRING",
    isOptional:"N",
    uiLabel:"Processing Start Date",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Processing Start Date",
    isRepeated:"Y",
    id: Math.random()+"_"+Math.random(),
  },
  processingTypeCodeProduct:{
    key:"processingTypeCodeProduct" + '.' + index,
    PGAId:"processingTypeCodeProduct",
    dataType:"STRING",
    isOptional:"N",
    uiLabel:"Source Type Code",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Source Type Code",
    isRepeated:"Y",
    id: Math.random()+"_"+Math.random(),
  },
  processingDescriptionProduct:{
    key:"processingDescriptionProduct" + '.' + index,
    PGAId:"processingDescriptionProduct",
    dataType:"STRING",
    isOptional:"N",
    uiLabel:"Processing Description",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Processing Description",
    isRepeated:"Y",
    id: Math.random()+"_"+Math.random(),
  },
  processingEndDateProduct:{
    key:"processingEndDateProduct" + '.' + index,
    PGAId:"processingEndDateProduct",
    dataType:"STRING",
    isOptional:"N",
    uiLabel:"Processing End Date",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Processing End Date",
    isRepeated:"Y",
    id: Math.random()+"_"+Math.random(),
  }
})




export const getAPHAVS_NAMEANDCODE_COMPONENT = (index=1) => ({
  categoryCodeComponent:{
    key: "categoryCodeComponent" + '.' + index,
    PGAId: "categoryCodeComponent",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "5AN",
    uiInputType: "DISPLAY",
    uiLabel: "Category Code",
    uiLabelDesc: "Category Code",
    id: Math.random()+"_"+Math.random(),
  },
  commonNameComponent: {
    key: "commonNameComponent" + '.' + index,
    PGAId: "commonNameComponent",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "30X",
    uiInputType: "DISPLAY",
    uiLabel: "Common Name Of Items",
    uiLabelDesc: "Common Name Of Items",
    id: Math.random()+"_"+Math.random(),
  },
  
})
export const getAPHAVS_COMMODITY_COMPONENT = (index=1) => ({
  commodityQualCodeComponent: {
    key: "commodityQualCodeComponent" + '.' + index,
    PGAId: "commodityQualCodeComponent",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "4X",
    uiInputType: "DISPLAY",
    uiLabel: "Commodity Qualifier Code",
    uiLabelDesc: "Commodity Qualifier Code",
    id: Math.random()+"_"+Math.random(),
  },
  charDescComponent: {
    key: "charDescComponent" + '.' + index,
    PGAId: "charDescComponent",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "57X",
    uiInputType: "DISPLAY",
    uiLabel: "Commodity Characteristic Description",
    uiLabelDesc: "Commodity Characteristic Description",
    id: Math.random()+"_"+Math.random(),
  },
  commodityCharQualComponent: {
    key: "commodityCharQualComponent" + '.' + index,
    PGAId: "commodityCharQualComponent",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "4AN",
    uiInputType: "DISPLAY",
    uiLabel: "Commodity Characteristic Qualifier",
    uiLabelDesc: "Commodity Characteristic Qualifier",
    id: Math.random()+"_"+Math.random(),
  }
})
export const getAPHAVS_SOURCE_TYPE_COMPONENT = (index = 1) => ({
  sourceTypeCodeComponent: {
    key: 'sourceTypeCodeComponent' + '.' + index,
    PGAId: 'sourceTypeCodeComponent',
    dataType: 'STRING',
    isOptional: 'N',
    uiLabel: 'Source Type Code',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Source Type Code',
    isRepeated: 'Y',
    lengthClass: '5AN',
    id: Math.random()+"_"+Math.random(),
  },
  countryComponent: {
    key: 'countryComponent' + '.' + index,
    PGAId: 'countryComponent',
    dataType: 'STRING',
    isOptional: 'N',
    uiLabel: 'Country',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Country',
    isRepeated: 'Y',
    id: Math.random()+"_"+Math.random(),
  },
  processingStartDateComponent:{
    key:"processingStartDateComponent" + '.' + index,
    PGAId:"processingStartDateComponent",
    dataType:"STRING",
    isOptional:"N",
    uiLabel:"Processing Start Date",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Processing Start Date",
    isRepeated:"Y",
    id: Math.random()+"_"+Math.random(),
  },
  processingTypeCodeComponent:{
    key:"processingTypeCodeComponent" + '.' + index,
    PGAId:"processingTypeCodeComponent",
    dataType:"STRING",
    isOptional:"N",
    uiLabel:"Source Type Code",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Source Type Code",
    isRepeated:"Y",
    id: Math.random()+"_"+Math.random(),
  },
  processingDescriptionComponent:{
    key:"processingDescriptionComponent" + '.' + index,
    PGAId:"processingDescriptionComponent",
    dataType:"STRING",
    isOptional:"N",
    uiLabel:"Processing Description",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Processing Description",
    isRepeated:"Y",
    id: Math.random()+"_"+Math.random(),
  },
  processingEndDateComponent:{
    key:"processingEndDateComponent" + '.' + index,
    PGAId:"processingEndDateComponent",
    dataType:"STRING",
    isOptional:"N",
    uiLabel:"Processing End Date",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Processing End Date",
    isRepeated:"Y",
    id: Math.random()+"_"+Math.random(),
  }
})

export const getFDADRU_LOTNUMSTUFF  =  (index = 1) => ({
	lotNum:{
    key: "lotNum" + "." + index,
    PGAId: "lotNum",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    uiInputType: "DISPLAY",
    uiLabel: "Lot Number",
    uiLabelDesc: "Lot Number",
    lengthClass: "25X",
    id: Math.random()+"_"+Math.random(),
  },
	lotNumQualifier:{
    key:"lotNumQualifier" + "." + index,
    dataType:"STRING",
    isOptional:"Y",
    uiLabel:"Lot Number Qualifier",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Lot Number Qualifier",
    PGAId:"lotNumQualifier",
    isRepeated:"Y",
    lengthClass: "1AN",
    id: Math.random()+"_"+Math.random(),
  },
	productionStartDate:{
    key:"productionStartDate" + "." + index,
    dataType:"STRING",
    isOptional:"Y",
    uiLabel:"Production Start Date",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Production Start Date",
    PGAId:"productionStartDate",
    isRepeated:"Y",
    lengthClass: "12X",
    id: Math.random()+"_"+Math.random(),
  },
    productionEndDate:{
    key:"productionEndDate" + "." + index,
    dataType:"STRING",
    isOptional:"Y",
    uiLabel:"Production End Date",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Production End Date",
    PGAId:"productionEndDate",
    isRepeated:"Y",
    lengthClass: "12X",
    id: Math.random()+"_"+Math.random(),
  },
  lineValue:{
    key:"lineValue" + "." + index,
    dataType:"STRING",
    isOptional:"N",
    uiLabel:"Line Value",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Line Value",
    PGAId:"lineValue",
    isRepeated:"Y",
    lengthClass: "12N",
    id: Math.random()+"_"+Math.random(),
  }
});

export const  getRepeatedArrivalLocation_Values  = (index = 1) => ({
  testingStatus:{
      key: "testingStatus" + "." + index,
      PGAId: "testingStatus",
      dataType: "STRING",
      isOptional: "N",
      isRepeated: "Y",
      lengthClass: "1A",
      uiInputType: "DISPLAY",
      uiLabel: "Arrival Inspection Status ",
      uiLabelDesc: "Arrival Inspection Status ",
      id: Math.random()+"_"+Math.random(),
    },
    arrivalDate:{
      key: "arrivalDate" + "." + index,
      PGAId: "arrivalDate",
      dataType: "STRING",
      isOptional: "Y",
      isRepeated: "Y",
      lengthClass: "15N",
      uiInputType: "DISPLAY",
      uiLabel: "Arrival Date ",
      uiLabelDesc: "Arrival Date",
      id: Math.random()+"_"+Math.random(),
    },
    arrivalLocation:{
      key: "arrivalLocation" + "." + index,
      PGAId: "arrivalLocation",
      dataType: "STRING",
      isOptional: "Y",
      isRepeated: "Y",
      lengthClass: "50X",
      uiInputType: "DISPLAY",
      uiLabel: "Arrival Location",
      uiLabelDesc: "Arrival Location",
      id: Math.random()+"_"+Math.random(),
    }
});

export const getDEADEA_constituent_Values  = (index = 1) => ({
  productCodeNo: {
    key: "productCodeNo" + "." + index,
    PGAId: "productCodeNo",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "19X",
    uiInputType: "DISPLAY",
    uiLabel: "Product Code Number",
    uiLabelDesc: "Product Code Number",
    id: Math.random()+"_"+Math.random(),
  },
  productCodeQualifier:{
    key: "productCodeQualifier" + "." + index,
    PGAId: "productCodeQualifier",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "4AN",
    uiInputType: "DISPLAY",
    uiLabel: "Product Code Qualifier",
    uiLabelDesc: "Product Code Qualifier",
    id: Math.random()+"_"+Math.random(),
  },
  constituentElementUnitOfMeasure: {
    key: "constituentElementUnitOfMeasure" + "." + index,
    PGAId: "constituentElementUnitOfMeasure",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "25X",
    uiInputType: "DISPLAY",
    uiLabel: "Constituent Element Unit Of Measure",
    uiLabelDesc: "Constituent Element Unit Of Measure",
    id: Math.random()+"_"+Math.random(),
  },
  constituentElementQuantity: {
    key: "constituentElementQuantity" + "." + index,
    PGAId: "constituentElementQuantity",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "12N",
    uiInputType: "DISPLAY",
    uiLabel: "Constituent Element Quantity",
    uiLabelDesc: "Constituent Element Quantity",
    id: Math.random()+"_"+Math.random(),
  },
})

const CPSC_REPEAT_META = Object.freeze({
  OPTIONAL_SINGLE: Object.freeze({ isOptional: 'Y', isRepeated: 'Y' }),
  REQUIRED_SINGLE: Object.freeze({ isOptional: 'N', isRepeated: 'Y' }),
  OPTIONAL_NESTED: Object.freeze({ isOptional: 'Y', isRepeated: 'YY' }),
  REQUIRED_NESTED: Object.freeze({ isOptional: 'N', isRepeated: 'YY' }),
})

const CPSC_REPEAT_META_BY_PGA_ID = Object.freeze({
  [CPSC_CITATION_FIELDS.ITL]: CPSC_REPEAT_META.REQUIRED_NESTED,
  [CPSC_CITATION_FIELDS.LAB]: CPSC_REPEAT_META.REQUIRED_NESTED,
  [CPSC_CITATION_FIELDS.NOL]: CPSC_REPEAT_META.REQUIRED_SINGLE,
  [CPSC_TEST_REPORT_FIELDS.QUALIFIER_ITL]: CPSC_REPEAT_META.OPTIONAL_NESTED,
  [CPSC_TEST_REPORT_FIELDS.INFORMATION_ITL]: CPSC_REPEAT_META.REQUIRED_NESTED,
  [CPSC_TEST_REPORT_FIELDS.QUALIFIER_LAB]: CPSC_REPEAT_META.OPTIONAL_NESTED,
  [CPSC_TEST_REPORT_FIELDS.INFORMATION_LAB]: CPSC_REPEAT_META.REQUIRED_NESTED,
})

const getCpscRepeatMeta = (pgaId, fallback = CPSC_REPEAT_META.OPTIONAL_SINGLE) =>
  CPSC_REPEAT_META_BY_PGA_ID[pgaId] || fallback

/** CPSC PGA — repeatable product identifier row (PG10-style). PGAIds from CPSC_PRODUCT_IDENTIFIER_FIELDS in CPSC_CPS/util. */
export const getCPSC_PRODUCT_IDENTIFIER_Values = (index = 1) => ({
  [CPSC_PRODUCT_IDENTIFIER_FIELDS.ITEM_TYPE]: {
    ...CPSC_REPEAT_META.REQUIRED_SINGLE,
    key: `${CPSC_PRODUCT_IDENTIFIER_FIELDS.ITEM_TYPE}.` + index,
    PGAId: CPSC_PRODUCT_IDENTIFIER_FIELDS.ITEM_TYPE,
    dataType: 'STRING',
    lengthClass: '4AN',
    uiInputType: 'DROPDOWN',
    uiLabel: 'Product ID Type',
    uiLabelDesc: 'Product ID Type',
    id: Math.random() + '_' + Math.random(),
    value: '',
  },
  [CPSC_PRODUCT_IDENTIFIER_FIELDS.PRODUCT_CODE_NO]: {
    ...CPSC_REPEAT_META.REQUIRED_SINGLE,
    key: `${CPSC_PRODUCT_IDENTIFIER_FIELDS.PRODUCT_CODE_NO}.` + index,
    PGAId: CPSC_PRODUCT_IDENTIFIER_FIELDS.PRODUCT_CODE_NO,
    dataType: 'STRING',
    lengthClass: '19x',
    uiInputType: 'DISPLAY',
    uiLabel: 'Product ID Number',
    uiLabelDesc: 'Product identifier number',
    id: Math.random() + '_' + Math.random(),
    value: '',
  },
})

const CPSC_ENTITY_LENGTH_CLASS_BY_PGA_ID = Object.freeze({
  entityNumberITL: '15X',
  individualNameLAB: '23X',
  entityNameLAB: '32X',
  entityNumberLAB: '15X',
  optionalBypassLAB: '1A',
  countryLAB: '2A',
  entityIdentificationCodeLAB: '3AN',
  stateLAB: '3AN',
  entityAddress1LAB: '23X',
  entityAddress2LAB: '32X',
  cityLAB: '21X',
  zipLAB: '9X',
  emailLAB: '35X',
  telNumberLAB: '15X',
})

const getCPSCEntityLengthClass = (pgaId) => CPSC_ENTITY_LENGTH_CLASS_BY_PGA_ID[pgaId] || '72X'

const getCPSC_ENTITY_ROW_Values = (pgaIds = [], index = 1) =>
  (pgaIds || []).reduce((acc, pgaId) => {
    acc[pgaId] = {
      ...CPSC_REPEAT_META.OPTIONAL_SINGLE,
      key: `${pgaId}.` + index,
      PGAId: pgaId,
      dataType: 'STRING',
      lengthClass: getCPSCEntityLengthClass(pgaId),
      uiInputType: 'DISPLAY',
      uiLabel: pgaId,
      uiLabelDesc: pgaId,
      id: Math.random() + '_' + Math.random(),
      value: '',
    }
    return acc
  }, {})

export const getCPSC_ENTITY_ITL_Values = (index = 1) =>
  getCPSC_ENTITY_ROW_Values(CPSC_ENTITY_FIELDS.ITL, index)

export const getCPSC_ENTITY_LAB_Values = (index = 1) =>
  getCPSC_ENTITY_ROW_Values(CPSC_ENTITY_FIELDS.LAB, index)

const getCPSC_CITATION_Values = (citationPgaId, index = 1) => ({
  [citationPgaId]: {
    ...getCpscRepeatMeta(citationPgaId),
    key: `${citationPgaId}.` + index,
    PGAId: citationPgaId,
    dataType: 'STRING',
    lengthClass: '72X',
    uiInputType: 'DISPLAY',
    uiLabel: 'Citation',
    uiLabelDesc: 'Citation',
    id: Math.random() + '_' + Math.random(),
    value: '',
  },
})

export const getCPSC_CITATION_ITL_Values = (index = 1) =>
  getCPSC_CITATION_Values(CPSC_CITATION_FIELDS.ITL, index)

export const getCPSC_CITATION_LAB_Values = (index = 1) =>
  getCPSC_CITATION_Values(CPSC_CITATION_FIELDS.LAB, index)

export const getCPSC_CITATION_NOL_Values = (index = 1) =>
  getCPSC_CITATION_Values(CPSC_CITATION_FIELDS.NOL, index)

const getCPSC_TEST_REPORT_ROW_Values = (qualifierPgaId, informationPgaId, index = 1) => ({
  [qualifierPgaId]: {
    ...getCpscRepeatMeta(qualifierPgaId),
    key: `${qualifierPgaId}.` + index,
    PGAId: qualifierPgaId,
    dataType: 'STRING',
    lengthClass: '3AN',
    uiInputType: 'DROPDOWN',
    uiLabel: 'Report Type',
    uiLabelDesc: 'Report Type',
    id: Math.random() + '_' + Math.random(),
    value: '',
  },
  [informationPgaId]: {
    ...getCpscRepeatMeta(informationPgaId, CPSC_REPEAT_META.REQUIRED_SINGLE),
    key: `${informationPgaId}.` + index,
    PGAId: informationPgaId,
    dataType: 'STRING',
    lengthClass: '72X',
    uiInputType: 'DISPLAY',
    uiLabel: 'Report Value',
    uiLabelDesc: 'Report Value',
    id: Math.random() + '_' + Math.random(),
    value: '',
  },
})

/** CPSC PGA — repeatable PG60 test report rows (ITL entity) */
export const getCPSC_TEST_REPORT_ITL_Values = (index = 1) =>
  getCPSC_TEST_REPORT_ROW_Values(
    CPSC_TEST_REPORT_FIELDS.QUALIFIER_ITL,
    CPSC_TEST_REPORT_FIELDS.INFORMATION_ITL,
    index
)

/** CPSC PGA — repeatable PG60 test report rows (LAB entity) */
export const getCPSC_TEST_REPORT_LAB_Values = (index = 1) =>
  getCPSC_TEST_REPORT_ROW_Values(
    CPSC_TEST_REPORT_FIELDS.QUALIFIER_LAB,
    CPSC_TEST_REPORT_FIELDS.INFORMATION_LAB,
    index
  )

export const getSIMPLE_LPCO_VALUES = (index = 1) => ({
  lpcoType : {
      "key": "lpcoType" + "." + index,
      "dataType": "STRING",
      "isOptional": "Y",
      "uiLabel": "LPCO Type",
      "uiInputType": "DISPLAY",
      "uiLabelDesc": "LPCO Type",
      "PGAId": "lpcoType",
      "isRepeated": "Y",
      "lengthClass": "3AN",
      id: Math.random() + "_" + Math.random(),
  },
  lpcoNumber : {
      "key": "lpcoNumber" + "." + index,
      "dataType": "STRING",
      "isOptional": "Y",
      "uiLabel": "LPCO Number",
      "uiInputType": "DISPLAY",
      "uiLabelDesc": "LPCO Number",
      "PGAId": "lpcoNumber",
      "isRepeated": "Y",
      "lengthClass": "33X",
      id: Math.random() + "_" + Math.random(),
  },
})

export const getAMS_OR2_LPCOTRANSACTION_Values = (index = 1) => ({
  lcpoTxnType: {
    "key": "lcpoTxnType" + "." + index,
    "dataType": "STRING",
    "isOptional": "Y",
    "uiLabel": "LPCO TRANSACTION TYPE",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "LPCO TRANSACTION TYPE",
    "PGAId": "lcpoTxnType",
    "isRepeated": "Y",
    "lengthClass": "1N",
    id: Math.random() + "_" + Math.random(),
  },
  "lcpoNumber": {
    "key": "lcpoNumber" + "." + index,
    "dataType": "STRING",
    "isOptional": "N",
    "uiLabel": "NOP Import Certificate Number",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "NOP Import Certificate Number",
    "PGAId": "lcpoNumber",
    "isRepeated": "Y",
    "lengthClass": "33X",
    id: Math.random() + "_" + Math.random(),
  },
})

export const getAMS_OR2_LOTNUMBER_Values = (index = 1) => ({

  "lotNum": {
    "key": "lotNum" + "." + index,
    "dataType": "STRING",
    "isOptional": "Y",
    "uiLabel": "LOT NUMBER",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "LOT NUMBER",
    "PGAId": "lotNum",
    "isRepeated": "N",
    "lengthClass": "25X",
    id: Math.random() + "_" + Math.random(),
  },
  "lotNumQualifier": {
    "key": "lotNumQualifier" + "." + index,
    "dataType": "STRING",
    "isOptional": "Y",
    "uiLabel": "LOT NUMBER QUALIFIER",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "LOT NUMBER QUALIFIER",
    "PGAId": "lotNumQualifier",
    "isRepeated": "N",
    "lengthClass": "1AN",
    id: Math.random() + "_" + Math.random(),
  },

})

export const getLACEY_ACT_REPEATED_Values = (index = 1) => ({
  genusName: {
    key: "genusName" + "." + index,
    PGAId: "genusName",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    uiInputType: "DISPLAY",
    uiLabel: "Genus Name",
    uiLabelDesc: "Genus Name",
    id: Math.random()+"_"+Math.random(),
  },
  speciesName: {
    key: "speciesName" + "." + index,
    PGAId: "speciesName",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    uiInputType: "DISPLAY",
    uiLabel: "Species Name",
    uiLabelDesc: "Species Name",
    id: Math.random()+"_"+Math.random(),
  },
  countryCode: {
    key: "countryCode" + "." + index,
    PGAId: "countryCode",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    uiInputType: "DISPLAY",
    uiLabel: "Country Code",
    uiLabelDesc: "Country Code",
    id: Math.random()+"_"+Math.random(),
  },
  indgredientName: {
    key: "indgredientName" + "." + index,
    PGAId: "indgredientName",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    uiInputType: "DISPLAY",
    uiLabel: "Ingredient Name",
    uiLabelDesc: "Ingredient Name",
    id: Math.random()+"_"+Math.random(),
  },
  indgredientQuantity: {
    key: "indgredientQuantity" + "." + index,
    PGAId: "indgredientQuantity",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    uiInputType: "DISPLAY",
    uiLabel: "Ingredient Quantity",
    uiLabelDesc: "Ingredient Quantity",
    id: Math.random()+"_"+Math.random(),
  },
  indgredientUom: {
    key: "indgredientUom" + "." + index,
    PGAId: "indgredientUom",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    uiInputType: "DISPLAY",
    uiLabel: "Ingredient UoM",
    uiLabelDesc: "Ingredient UoM",
    id: Math.random()+"_"+Math.random(),
  },
  indgredientPercentage: {
    key: "indgredientPercentage" + "." + index,
    PGAId: "indgredientPercentage",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    uiInputType: "DISPLAY",
    uiLabel: "Ingredient Percentage",
    uiLabelDesc: "Ingredient Percentage",
    id: Math.random()+"_"+Math.random(),
  },
  })

export const getCOMO_Values = (index = 1) => ({
  comoRoutingCountryCode: {
    key: "comoRoutingCountryCode" + "." + index,
    PGAId: "comoRoutingCountryCode",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    uiInputType: "DISPLAY",
    uiLabel: "Commodity Routing Country Code",
    uiLabelDesc: "Commodity Routing Country Code",
    id: Math.random()+"_"+Math.random(),
  },
  comoRoutingRegionCode: {
    key: "comoRoutingRegionCode" + "." + index,
    PGAId: "comoRoutingRegionCode",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    uiInputType: "DISPLAY",
    uiLabel: "Commodity Political Subunit of Routing Name",
    uiLabelDesc: "Commodity Political Subunit of Routing Name",
    id: Math.random()+"_"+Math.random(),
  },
  comoRoutingTypeCode: {
    key: "comoRoutingTypeCode" + "." + index,
    PGAId: "comoRoutingTypeCode",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    uiInputType: "DISPLAY",
    uiLabel: "Commodity Routing Type Code",
    uiLabelDesc: "Commodity Routing Type Code",
    id: Math.random()+"_"+Math.random(),
  },
})
export const getAdvanced_Containers = (index = 1) =>({
    containerType :{
      key: "containerType" + "." + index,
      PGAId: "containerType",
      dataType: "STRING",
      isOptional: "N",
      isRepeated: "Y",
      uiInputType: "DISPLAY",
      uiLabel: "Type of Container",
      uiLabelDesc: "Type of Container",
      value: "",
      id: Math.random()+"_"+Math.random(),
    },
    containerNum: { 
      key: "containerNum" + "." + index,
      PGAId: "containerNum",
      dataType: "STRING",
      isOptional: "N",
      isRepeated: "Y",
      uiInputType: "DISPLAY",
      uiLabel: "Container Number",
      uiLabelDesc: "Container Number",
      value: "",
      lengthClass: "20AN",
      id: Math.random()+"_"+Math.random(),
    } ,
    containerLength: {
      key: "containerLength" + "." + index,
      PGAId: "containerLength",
      dataType: "STRING",
      isOptional: "N",
      isRepeated: "Y",
      uiInputType: "DISPLAY",
      uiLabel: "Container length",
      uiLabelDesc: "Container length",
      value: "",
      id: Math.random()+"_"+Math.random(),
    }


})
export const getORRemarks_Values = (index = 1) => ({
  remarksText: {
    key: "remarksText" + "." + index,
    PGAId: "remarksText",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "68X",
    uiInputType: "DISPLAY",
    uiLabel: "Remarks",
    uiLabelDesc: "Remarks",
    id: Math.random()+"_"+Math.random(),
  },
  remarksTypeCode: {
    key: "remarksTypeCode" + "." + index,
    PGAId: "remarksTypeCode",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "3AN",
    uiInputType: "DISPLAY",
    uiLabel: "Remarks Type Code",
    uiLabelDesc: "Remarks Type Code",
    id: Math.random()+"_"+Math.random(),
  }, remarksCode: {
    key: "remarksCode" + "." + index,
    PGAId: "remarksCode",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "5AN",
    uiInputType: "DISPLAY",
    uiLabel: "Remarks Code",
    uiLabelDesc: "Remarks Code",
    id: Math.random()+"_"+Math.random(),
  }
})
export const getLPCO_Values = (index = 1) => ({
  lcpoDate: {
  PGAId: "lcpoDate",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  key: "lcpoDate" + "." + index,
  uiInputType: "DISPLAY",
  uiLabel: "LPCO Date",
  uiLabelDesc: "LPCO Date",
  lengthClass: "15N",
  id: Math.random()+"_"+Math.random(),
  },
  lcpoDateQual:{
  PGAId: "lcpoDateQual",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  key: "lcpoDateQual" + "." + index,
  uiInputType: "DISPLAY",
  uiLabel: "LPCO Date Qual",
  uiLabelDesc: "LPCO Date Qual",
  lengthClass: "1N",
  id: Math.random()+"_"+Math.random(),
  },
  lcpoLocationDesc:{
    key: "lcpoLocationDesc" + "." + index,
    value: "MD",
    dataType: "STRING",
    isOptional: "Y",
    uiLabel: "Regional description of location of Agency Issuing the LPCO",
    uiInputType: "DISPLAY",
    uiLabelDesc: "Regional description of location of Agency Issuing the LPCO",
    PGAId: "lcpoLocationDesc",
    isRepeated: "Y",
    lengthClass: "25X",
    id: Math.random()+"_"+Math.random(),
  },
  lcpoIssuer:{
  PGAId: "lcpoIssuer",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  key: "lcpoIssuer" + "." + index,
  uiInputType: "DISPLAY",
  uiLabel: "LPCO Issuer - Government Geographic Code Qualifier",
  uiLabelDesc: "LPCO Issuer - Government Geographic Code Qualifier",
  lengthClass: "35X",
  id: Math.random()+"_"+Math.random(),
  },
  lcpoLocation:{
  PGAId: "lcpoLocation",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  key: "lcpoLocation" + "." + index,
  uiInputType: "DISPLAY",
  uiLabel: "Location (Country/State /Province) of Issuer of the LPCO",
  uiLabelDesc: "Location (Country/State /Province) of Issuer of the LPCO",
  lengthClass: "3A",
  id: Math.random()+"_"+Math.random(),
  },
  lcpoLocationDesc:{
  PGAId: "lcpoLocationDesc",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  key: "lcpoLocationDesc" + "." + index,
  uiInputType: "DISPLAY",
  uiLabel: "Regional description of location of Agency Issuing the LPCO",
  uiLabelDesc: "Regional description of location of Agency Issuing the LPCO",
  lengthClass: "25X",
  id: Math.random()+"_"+Math.random(),
  },
  lcpoTxnType : {
    key: "lcpoTxnType" + "." + index,
    PGAId: "lcpoTxnType",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "1N",
    uiInputType: "DISPLAY",
    uiLabel: "Lcpo Transaction Type",
    uiLabelDesc: "Lcpo Transaction Type",
    id: Math.random()+"_"+Math.random(),
  },
  lcpoNumber:{
  PGAId: "lcpoNumber",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  key: "lcpoNumber" + "." + index,
  uiInputType: "DISPLAY",
  uiLabel: "LPCO Number",
  uiLabelDesc: "LPCO Number",
  lengthClass: "33X",
  id: Math.random()+"_"+Math.random(),
  },
  lcpoQuantity:{
  PGAId: "lcpoQuantity",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  key: "lcpoQuantity" + "." + index,
  uiInputType: "DISPLAY",
  uiLabel: "LPCO Quantity",
  uiLabelDesc: "LPCO Quantity",
  lengthClass: "16N",
  id: Math.random()+"_"+Math.random(),
  },
  lcpoType:{
  PGAId: "lcpoType",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  key: "lcpoType" + "." + index,
  uiInputType: "DISPLAY",
  uiLabel: "LPCO Type",
  uiLabelDesc: "LPCO Type",
  lengthClass: "3AN",
  id: Math.random()+"_"+Math.random(),
  },
  lcpoUom:{
  PGAId: "lcpoUom",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  key: "lcpoUom" + "." + index,
  uiInputType: "DISPLAY",
  uiLabel: "LPCO Unit of Measure",
  uiLabelDesc: "LPCO Unit of Measure",
  lengthClass: "5AN",
  id: Math.random()+"_"+Math.random(),
  }
});

export const getPSX_REPEATED_INGREDIENT_Values = (index = 1) => ({
  indgredientPercent: {
  PGAId: "indgredientPercent",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  key: "indgredientPercent" + "." + index,
  lengthClass: "7N",
  uiInputType: "DISPLAY",
  uiLabel: "Constituent Element Percent",
  uiLabelDesc: "Constituent Element Percent",
  id: Math.random()+"_"+Math.random(),
  
},
indgredientName:{
  
  PGAId: "indgredientName",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  key: "indgredientName" + "." + index,
  lengthClass: "51X",
  uiInputType: "DISPLAY",
  uiLabel: "Constituent Element Name",
  uiLabelDesc: "Constituent Element Name",
  id: Math.random()+"_"+Math.random(),
}})

export const getATFATF_LICENSE_Values =  (index = 1) => ({

  exemptionCode :{
    PGAId:"exemptionCode",
    dataType:"STRING",
    id: Math.random()+"_"+Math.random(),
    isOptional:"Y",
    isRepeated:"Y",
    key:"exemptionCode" + '.' + index,
    lengthClass:"9X",
    uiInputType:"DISPLAY",
    uiLabel:"ExemptionCode",
    uiLabelDesc:"Exemption Code",
  },
  lcpoNumber:{
    PGAId: "lcpoNumber",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    key: "lcpoNumber" + "." + index,
    uiInputType: "DISPLAY",
    uiLabel: "LPCO Number",
    uiLabelDesc: "LPCO Number",
    lengthClass: "33X",
    id: Math.random()+"_"+Math.random(),
  },
  lcpoType:{
  PGAId: "lcpoType",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  key: "lcpoType" + "." + index,
  uiInputType: "DISPLAY",
  uiLabel: "LPCO Type",
  uiLabelDesc: "LPCO Type",
  lengthClass: "3AN",
  id: Math.random()+"_"+Math.random(),
  },
})


export const getFSI_FSI_LOT_LLL_Values = (index = 1) => ({
  entityNumberEXE:{
    PGAId: "entityNumberEXE",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "YY",
    key: "entityNumberEXE" + '.' + index,
    lengthClass: "15X",
    uiInputType: "DISPLAY",
    uiLabel: "Foreign Exporting Establishment Entity Number",
    uiLabelDesc: "Foreign Exporting Establishment Entity Number",
    id: Math.random()+"_"+Math.random(),
  },
  entityNumberPE:{
    PGAId: "entityNumberPE",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "YY",
    key: "entityNumberPE" + '.' + index,
    lengthClass: "15X",
    uiInputType: "DISPLAY",
    uiLabel: "Foreign Producing Establishment Entity Number",
    uiLabelDesc: "Foreign Producing Establishment Entity Number",
    id: Math.random()+"_"+Math.random(),
  },
  entityNumberSOE:{
    PGAId: "entityNumberSOE",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "YY",
    key: "entityNumberSOE" + '.' + index,
    lengthClass: "15X",
    uiInputType: "DISPLAY",
    uiLabel: "Foreign Producing Establishment Entity Number",
    uiLabelDesc: "Foreign Producing Establishment Entity Number",
    id: Math.random()+"_"+Math.random(),
  },
  productionEndDate:{
    PGAId: "productionEndDate",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "YY",
    key: "productionEndDate" + '.' + index,
    lengthClass: "15N",
    uiInputType: "DISPLAY",
    uiLabel: "Production End Date (If Applicable)",
    uiLabelDesc: "Production End Date (If Applicable)",
    id: Math.random()+"_"+Math.random(),
  },
  productionStartDate:{
    PGAId: "productionStartDate",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "YY",
    key: "productionStartDate" + '.' + index,
    lengthClass: "15N",
    uiInputType: "DISPLAY",
    uiLabel: "Production Start Date (If Applicable)",
    uiLabelDesc: "Production Start Date (If Applicable)",
    id: Math.random()+"_"+Math.random(),
  },
  quantitypgaNet:{
    PGAId: "quantitypgaNet",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "YY",
    key: "quantitypgaNet" + '.' + index,
    lengthClass: "3AN",
    uiInputType: "DISPLAY",
    uiLabel: "Lot Net Weight (lbs)",
    uiLabelDesc: "Lot Net Weight (lbs)",
    id: Math.random()+"_"+Math.random(),
  },
  packagingIdentifier: {
    PGAId: "packagingIdentifier",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "YY",
    key: "packagingIdentifier" + '.' + index,
    lengthClass: "25X",
    uiInputType: "DISPLAY",
    uiLabel: "Shipping Mark/Identification",
    uiLabelDesc: "Shipping Mark/Identification",
    id: Math.random()+"_"+Math.random(),
  },
  commodityQualCode: {
      key: "commodityQualCode" + '.' + index,
      PGAId: "commodityQualCode",
      dataType: "STRING",
      isOptional: "Y",
      isRepeated: "Y",
      lengthClass: "4X",
      uiInputType: "DISPLAY",
      uiLabel: "Commodity Qualifier Code",
      uiLabelDesc: "Commodity Qualifier Code",
    id: Math.random()+"_"+Math.random(),
  },
  commodityCharQual: {
      key: "commodityCharQual" + '.' + index,
      PGAId: "commodityCharQual",
      dataType: "STRING",
      isOptional: "Y",
      isRepeated: "Y",
      lengthClass: "4AN",
      uiInputType: "DISPLAY",
      uiLabel: "Commodity Characteristic Qualifier",
      uiLabelDesc: "Commodity Characteristic Qualifier",
    id: Math.random()+"_"+Math.random(),
  },
  categoryCode: {
    PGAId: "categoryCode",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "YY",
    key: "categoryCode" + '.' + index,
    lengthClass: "5AN",
    uiInputType: "DISPLAY",
    uiLabel: "Category Code",
    uiLabelDesc: "Category Code",
    id: Math.random()+"_"+Math.random(),
  }
});

export const getConformanceDoc_Values = (index = 1) => ({
  documentIdentifier: {
    key: "documentIdentifier" + '.' + index,
    PGAId: "documentIdentifier",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "4N",
    uiInputType: "DISPLAY",
    uiLabel: "Conformance Document",
    uiLabelDesc: "Conformance Document",
    id: Math.random()+"_"+Math.random(),
  }
});

export const getVehicleVin_Values = (index = 1) => ({
  itemIdentity:{
    key: "itemIdentity" + '.' + index,
    PGAId: "itemIdentity",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "YY",
    lengthClass: "17X",
    uiInputType: "DISPLAY",
    uiLabel: "Item Identity",
    uiLabelDesc: "Item Identity",
    id: Math.random()+"_"+Math.random(),
  },
});
export const getVehicle_Values = (index = 1) => ({
  model:{
    key: "model" + '.' + index,
    PGAId: "model",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "15X",
    uiInputType: "DISPLAY",
    uiLabel: "Model",
    uiLabelDesc: "Model",
    id: Math.random()+"_"+Math.random(),
  },
  manufactureMonthAndYear:{
    key: "manufactureMonthAndYear" + '.' + index,
    PGAId: "manufactureMonthAndYear",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "15N",
    uiInputType: "DISPLAY",
    uiLabel: "Manufacture Month and Year",
    uiLabelDesc: "Manufacture Month and Year",
    id: Math.random()+"_"+Math.random(),
  },
  categoryCode:{
    key: "categoryCode" + '.' + index,
    PGAId: "categoryCode",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "15X",
    uiInputType: "DISPLAY",
    uiLabel: "Category Code",
    uiLabelDesc: "Category Code",
    id: Math.random()+"_"+Math.random(),
  },
  commodityQualCode:{
    key: "commodityQualCode" + '.' + index,
    PGAId: "commodityQualCode",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "4X",
    uiInputType: "DISPLAY",
    uiLabel: "Model Year",
    uiLabelDesc: "Model Year",
    id: Math.random()+"_"+Math.random(),
  },
  commodityCharQual:{
    key: "commodityCharQual" + '.' + index,
    PGAId: "commodityCharQual",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "2X",
    uiInputType: "DISPLAY",
    uiLabel: "Drive Side",
    uiLabelDesc: "Drive Side",
    id: Math.random()+"_"+Math.random(),
  }
});

export const getEPA_VNE_PRODUCTCOMPONENT_Values = (index = 1) => ({
  identityNumberProduct:{
    key: "identityNumberProduct" + '.' + index,
  PGAId: "identityNumberProduct",
  dataType: "STRING",
  isOptional: "N",
  isRepeated: "Y",
  lengthClass: "17X",
  uiInputType: "DISPLAY",
  uiLabel: "Identity Number",
  uiLabelDesc: "Identity Number",
  id: Math.random()+"_"+Math.random(),
  },identityNumberComponent:{
    key: "identityNumberComponent" + '.' + index,
  PGAId: "identityNumberComponent",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  lengthClass: "17X",
  uiInputType: "DISPLAY",
  uiLabel: "Identity Number",
  uiLabelDesc: "Identity Number",
  id: Math.random()+"_"+Math.random(),
  },modelComponent:{
    key: "modelComponent" + '.' + index,
  PGAId: "modelComponent",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  lengthClass: "15X",
  uiInputType: "DISPLAY",
  uiLabel: "Model",
  uiLabelDesc: "Model",
  id: Math.random()+"_"+Math.random(),
  },modelProduct:{
    key: "modelProduct" + '.' + index,
  PGAId: "modelProduct",
  dataType: "STRING",
  isOptional: "N",
  isRepeated: "Y",
  lengthClass: "15X",
  uiInputType: "DISPLAY",
  uiLabel: "Model",
  uiLabelDesc: "Model",
  id: Math.random()+"_"+Math.random(),
  },mfgMonthYearComponent:{
    key: "mfgMonthYearComponent" + '.' + index,
  PGAId: "mfgMonthYearComponent",
  dataType: "STRING",
  isOptional: "Y",
  isRepeated: "Y",
  lengthClass: "6N",
  uiInputType: "DISPLAY",
  uiLabel: "Manufacture Month and Year",
  uiLabelDesc: "Manufacture Month and Year",
  id: Math.random()+"_"+Math.random(),
  },
    mfgMonthYearProduct:{
      key: "mfgMonthYearProduct" + '.' + index,
    PGAId: "mfgMonthYearProduct",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "6N",
    uiInputType: "DISPLAY",
    uiLabel: "Manufacture Month and Year",
    uiLabelDesc: "Manufacture Month and Year",
    id: Math.random()+"_"+Math.random(),
    
  },addComponent: {
    key: "addComponent" + '.' + index,
    PGAId: "addComponent",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "1X",
    uiInputType: "DISPLAY",
    uiLabel: "Add Engine",
    uiLabelDesc: "Add Engine",
    value: "Y",
    id: Math.random()+"_"+Math.random(),
  },qualifierComponent:{
    key: "qualifierComponent" + '.' + index,
    PGAId: "qualifierComponent",
    dataType: "STRING",
    isOptional: "Y",
    isRepeated: "Y",
    lengthClass: "3AN",
    uiInputType: "DISPLAY",
    uiLabel: "Item Identity Qualifier",
    uiLabelDesc: "Item Identity Qualifier",
    value: 'ENN',
    id: Math.random()+"_"+Math.random(),
  },qualifierProduct:{
    key: "qualifierProduct" + '.' + index,

    PGAId: "qualifierProduct",
    dataType: "STRING",
    isOptional: "N",
    isRepeated: "Y",
    lengthClass: "3AN",
    uiInputType: "DISPLAY",
    uiLabel: "Item Identity Qualifier",
    uiLabelDesc: "Item Identity Qualifier",
    value: 'AKG',
    id: Math.random()+"_"+Math.random(),
  }
});
export const getFDADRU_CONSTITUENT_ELEMENT =  (index = 1) => ({
  constituentElementQuantity: {
    key:'constituentElementQuantity' + '.' + index,
    dataType:"STRING",
    isOptional:"Y",
    uiLabel:"Constituent Element Quantity",
    uiInputType:"DISPLAY",
    uiLabelDesc:"Constituent Element Quantity",
    PGAId:"constituentElementQuantity",
    isRepeated:"Y",
    lengthClass: "12N",
    id: Math.random()+"_"+Math.random(),
  },
  constituentElementUnitOfMeasure:{
    "key":'constituentElementUnitOfMeasure' + '.' + index,
    "dataType":"STRING",
    "isOptional":"Y",
    "uiLabel":"Unit of Measure",
    "uiInputType":"DISPLAY",
    "uiLabelDesc":"Unit of Measure",
    "PGAId":"constituentElementUnitOfMeasure",
    "isRepeated":"Y",
    "lengthClass": "25X",
    id: Math.random()+"_"+Math.random(),
  },
  constituentElementPercent:{
    "key":'constituentElementPercent' + '.' + index,
    "dataType":"STRING",
    "isOptional":"Y",
    "uiLabel":"Constituent Element Percent",
    "uiInputType":"DISPLAY",
    "uiLabelDesc":"Constituent Element Percent",
    "PGAId":"constituentElementPercent",
    "isRepeated":"Y",
    "lengthClass": "7N",
    id: Math.random()+"_"+Math.random(),
  },
  constituentElementName:{
    "key":'constituentElementName' + '.' + index,
    "dataType":"STRING",
    "isOptional":"Y",
    "uiLabel":"Constituent Element Name",
    "uiInputType":"DISPLAY",
    "uiLabelDesc":"Constituent Element Name",
    "PGAId":"constituentElementName",
    "isRepeated":"Y",
    "lengthClass": "51X",
    id: Math.random()+"_"+Math.random(),
  }
})
export const getFDAFOO_PQ = (index = 1) => ({
  packagingQualifier: {
    key: 'packagingQualifier' + '.' + index,
    dataType: 'STRING',
    isOptional: 'N',
    uiLabel: 'Packaging Qualifier',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Packaging Qualifier',
    PGAId: 'packagingQualifier',
    isRepeated: 'Y',
    lengthClass: '1N',
    id: Math.random()+"_"+Math.random(),
  },
  quantity: {
    key: 'quantity' + '.' + index,
    dataType: 'STRING',
    isOptional: 'Y',
    uiLabel: 'Quantity',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Quantity',
    PGAId: 'quantity',
    isRepeated: 'Y',
    lengthClass: '12N',
    id: Math.random()+"_"+Math.random(),
  },
  uom: {
    key: 'uom' + '.' + index,
    dataType: 'STRING',
    isOptional: 'Y',
    uiLabel: 'Unit Of Measure',
    uiInputType: 'DISPLAY',
    uiLabelDesc: 'Unit Of Measure',
    PGAId: 'uom',
    isRepeated: 'Y',
    lengthClass: '3AN',
    id: Math.random()+"_"+Math.random(),
  }
})

export const container = () => ({
  number: '',
  size: '',
  containerId: ''
})


export const manufacturer = () => ({
  headerPartyType: "MANUFACTURER",
  name: "",
  addressInfo: {
    STREET_NAME: [],
    CITY: '',
    COUNTRY_SUB_ENTITY: '',
    POSTAL_CODE: '',
    COUNTRY: ''
  },
  headerId: ""
})

export const invoiceItemData = () => ({
  invoiceId: "",
      invoiceNumber: "",
      invoiceDate: null,
      poNumber: "",
      invoiceAmount: (0).toFixed(2),
      frieghtCharges: (0).toFixed(2),
      frieghtInsurance: (0).toFixed(2),
      otherDeductions: (0).toFixed(2),
      totalEnteredValue: (0).toFixed(2),

      merchandiseLineItems: [merchandiseLineItem()],
})

export const checkFrieghtShouldBeDispalyed = (totalAdditions,totalDeletions) => {
 return  (parseFloat(totalAdditions || 0.0)>0 || parseFloat(totalDeletions || 0.0)>0)
}

export  const checkInvoiceIsOpen  = (index) => {
  return true;
// if(index < 5){
//   return  true
// }else{
//   return false
// }
}

export const get_REPEATED_NMF_370_HARVEST_Values= (index = 1) => ({
  gearType: {
    "id": Math.random()+"_"+Math.random(),
    "key": "gearType" + '.' + index,
    "dataType": "STRING",
    "isOptional": "N",
    "uiLabel": "Gear Type",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "Gear Type",
    "PGAId": "gearType",
    "isRepeated": "Y",
    "lengthClass": "5AN",
    "possibleValues": [
      {
        "value": "DN",
        "description": "Large Scale Driftnet (High Seas)"
      },
      {
        "value": "GN",
        "description": "Gillnet less than 1.5 miles (2.4 km) in total length"
      },
      {
        "value": "LL",
        "description": "Longline"
      },
      {
        "value": "OTH",
        "description": "Other Type"
      },
      {
        "value": "PL",
        "description": "Pole and Line, Hook and Line"
      },
      {
        "value": "PS",
        "description": "Purse Seine Net"
      }
    ]
  },
  geographicLocation: {
    "id": Math.random()+"_"+Math.random(),
    "key": "geographicLocation" + '.' + index,
    "dataType": "STRING",
    "isOptional": "N",
    "uiLabel": "Ocean Area",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "Ocean Area",
    "PGAId": "geographicLocation",
    "isRepeated": "Y",
    "lengthClass": "20X",
    "possibleValues": [
      {
        "value": "CAR",
        "description": "Caribbean Sea"
      },
      {
        "value": "EA",
        "description": "Eastern Atlantic Ocean"
      },
      {
        "value": "ETP",
        "description": "Eastern Tropical Pacific Ocean east of 160 W"
      },
      {
        "value": "IND",
        "description": "Indian Ocean"
      },
      {
        "value": "NP",
        "description": "North Pacific Ocean"
      },
      {
        "value": "OTH",
        "description": "Other - Describe Area"
      },
      {
        "value": "SP",
        "description": "South Pacific Ocean"
      },
      {
        "value": "WA",
        "description": "Western Atlantic Ocean"
      },
      {
        "value": "WP",
        "description": "Western Pacific Ocean west of 160 W"
      }
    ]
  }
})

export const get_REPEATED_NMF_370_BOX5_Values= (index = 1) => ({
  boxBDolphCertSafeChoices: {
    "id": Math.random()+"_"+Math.random(),
    "key": "boxBDolphCertSafeChoices" + '.' + index,
    "dataType": "STRING",
    "isOptional": "N",
    "uiLabel": "Tuna/Tuna Products Certified Dolphin Safe",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "Tuna/Tuna Products Certified Dolphin Safe",
    "PGAId": "boxBDolphCertSafeChoices",
    "isRepeated": "Y"
  },
  boxBDolphCertSafe: {
    "id": Math.random()+"_"+Math.random(),
    "key": "boxBDolphCertSafe"  + '.' + index,
    "dataType": "STRING",
    "isOptional": "N",
    "uiLabel": "Box B Certified Dolphin Safe",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "Box B Certified Dolphin Safe",
    "PGAId": "boxBDolphCertSafe",
    "isRepeated": "Y",
    "lengthClass": "3N",
    "possibleValues": [
      {
        "description": "Tuna not harvested with a purse seine net...",
        "value": "1"
      },
      {
        "description": "Tuna harvested using a purse seine net outside the Eastern Tropical Pacific Ocean (ETP)...",
        "value": "2"
      },
      {
        "description": "Tuna harvested in a fishery which the Asst Administrator has determined...",
        "value": "3"
      },
      {
        "description": "Tuna harvested in the Eastern Tropcial Pacific Ocean (ETP) by a purse seine vessel  having a carrying capacity of 400 short tons or less...",
        "value": "4"
      },
      {
        "description": "Tuna harvested in the Eastern Tropcial Pacific Ocean (ETP) by a purse seine vessel  having a carrying capacity of more than 400 short tons or less...",
        "value": "5"
      }
    ]
  }
})

export const get_REPEATED_NMF_HMS_HARVEST_Values= (index = 1) => ({
  gearType: {
    "id": Math.random()+"_"+Math.random(),
    "key": "gearType" + '.' + index,
    "dataType": "STRING",
    "isOptional": "N",
    "uiLabel": "Gear Type",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "Gear Type",
    "PGAId": "gearType",
    "isRepeated": "Y",
    "lengthClass": "5AN"
  },
  geographicLocation: {
    "id": Math.random()+"_"+Math.random(),
    "key": "geographicLocation" + '.' + index,
    "dataType": "STRING",
    "isOptional": "N",
    "uiLabel": "Ocean Area",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "Ocean Area",
    "PGAId": "geographicLocation",
    "isRepeated": "Y",
    "lengthClass": "20X"
  },
  countryCode: {
    "id": Math.random()+"_"+Math.random(),
    "key": "countryCode" + '.' + index,
    "dataType": "STRING",
    "isOptional": "N",
    "uiLabel": "Harvest Location Country Code",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "Country Code of Harvest",
    "PGAId": "countryCode",
    "isRepeated": "Y",
    "lengthClass": "2X",
  },
  vesselFlag: {
    "id": Math.random()+"_"+Math.random(),
    "key": "vesselFlag" + '.' + index,
    "dataType": "STRING",
    "isOptional": "N",
    "uiLabel": "Vessel Flag",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "Vessel Flag",
    "PGAId": "vesselFlag",
    "isRepeated": "Y",
    "lengthClass": "35X"
  }
})

export const get_REPEATED_NMF_HMS_DOCUMENT_Values= (index = 1) => ({
  documentNumber: {
    "id": Math.random()+"_"+Math.random(),
    "key": "documentNumber" + '.' + index,
    "dataType": "STRING",
    "isOptional": "N",
    "uiLabel": "Document No.",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "Document No. ",
    "PGAId": "documentNumber",
    "isRepeated": "Y",
    "lengthClass": "30X"
  },
  documentIdentifier: {
    "id": Math.random()+"_"+Math.random(),
    "key": "documentIdentifier" + '.' + index,
    "dataType": "STRING",
    "isOptional": "N",
    "uiLabel": "Document(s) Submitted",
    "uiInputType": "DISPLAY",
    "uiLabelDesc": "Document(s) Submitted ",
    "PGAId": "documentIdentifier",
    "isRepeated": "Y",
    "lengthClass": "7AN"
  }
})